import React from "react";
import logoImg from "../assets/logo-neotec.png";

function Logo({ className = "", showScan = true }) {
  return (
    <div
      className={`relative flex items-center justify-center overflow-hidden rounded-xl ${className}`}
    >
      {/* Laser Scanline Effect - Tech Ping-Pong Vertical Scan */}
      {showScan && <div className="laser-scan-line" />}

      <img
        src={logoImg}
        alt="NEOtec Logo"
        className="h-8 md:h-10 lg:h-12 w-auto object-contain"
      />
    </div>
  );
}

export default Logo;
